var _linearGradient, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundcloudLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Ke5cRwe9ua_Q0F8Xn-Y0ua",
    x1: 24.083,
    x2: 24.083,
    y1: 8.738,
    y2: 34.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#fe651e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Ke5cRwe9ua_Q0F8Xn-Y0ua)",
    d: "M10,33.018c0.596,0,1.265,0,2,0V19.041c-1.11,1.001-1.699,2.212-2,3.121V33.018z M21,18.105 c-0.675-0.316-1.752-0.715-3-0.837v15.749c0.976,0,1.98,0,3,0V18.105z M14,33.018c0.943,0,1.95,0,3,0V17.24 c-1.173,0.03-2.171,0.23-3,0.558V33.018z M4,23.953c-1.178,0.896-2,2.35-2,4.039c0,1.586,0.795,2.987,2,3.905V23.953z M40.995,22.016c-1.444,0-2.283,0.521-2.283,0.521s-0.839-8.488-9.271-8.488c-4.906,0-6.83,2.704-7.441,3.897v15.071 c8.825,0,18.297,0,18.297,0s5.869-0.094,5.869-5.453C46.166,23.439,42.439,22.016,40.995,22.016z M8,23.1 c-0.395-0.051-0.842-0.088-1.341-0.088c-0.223,0-0.441,0.037-0.659,0.073v9.767c0.423,0.104,0.861,0.166,1.311,0.166 c0.151,0,0.393,0,0.689,0V23.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloudLogo);
export default __webpack_public_path__ + "static/media/soundcloud-logo.fc3a155cb8b294fd538507d7de5ea957.svg";
export { ForwardRef as ReactComponent };